import React from "react"

export default ({ primary, items }) => {
  return <pre>{JSON.stringify({ primary, items }, null, 2)}</pre>
}
